import type { CLSToSDSData } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

type GetMatchIdsParams = {
  id: string
}

function getMatchIds(params: GetMatchIdsParams): Promise<CLSToSDSData> {
  const { id } = params

  return requestApiJsonOrThrow<CLSToSDSData>(`admin/id-lookup/${id}`)
}

export const matchIdsQuery = (params: GetMatchIdsParams) => ({
  queryKey: ['match-ids', params],
  queryFn: () => getMatchIds(params),
})
